import {SET_TOPIC_COLORS} from '../actions/actionTypes';

export default (state={}, action) => {
    if (action.type === SET_TOPIC_COLORS) {
        return action.topicColors;
    }
    return state;
}
